const thesaurus =
{
    helmet :
    {
        title : 'Thésaurus' ,
        metas : []
    }
};

export default thesaurus ;